var _path, _g, _g2, _g3, _path2, _g4, _g5, _g6, _g7, _g8, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReactionObsessed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 79,
    viewBox: "0 0 78 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62.8612 39.6786C62.8612 52.6546 52.3421 63.1737 39.3661 63.1737C26.3902 63.1737 15.8711 52.6546 15.8711 39.6786C15.8711 26.7027 26.3902 16.1836 39.3661 16.1836C52.3421 16.1836 62.8612 26.7027 62.8612 39.6786Z",
    fill: "url(#paint0_radial_3003_69648)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_3003_69648)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 29.7266,
    cy: 36.2285,
    r: 10.5,
    fill: "url(#paint1_radial_3003_69648)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 29.7266,
    cy: 36.2285,
    r: 10.5,
    fill: "url(#paint2_radial_3003_69648)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_3003_69648)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 10.5,
    transform: "matrix(-1 0 0 1 49.7266 36.2285)",
    fill: "url(#paint3_radial_3003_69648)"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 10.5,
    transform: "matrix(-1 0 0 1 49.7266 36.2285)",
    fill: "url(#paint4_radial_3003_69648)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_3003_69648)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 39.2266,
    cy: 26.2285,
    rx: 10,
    ry: 7.5,
    fill: "white",
    fillOpacity: 0.7
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3003_69648",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 16,
    width: 48,
    height: 48
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M62.8612 39.6786C62.8612 52.6546 52.3421 63.1737 39.3661 63.1737C26.3902 63.1737 15.8711 52.6546 15.8711 39.6786C15.8711 26.7027 26.3902 16.1836 39.3661 16.1836C52.3421 16.1836 62.8612 26.7027 62.8612 39.6786Z",
    fill: "url(#paint5_radial_3003_69648)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3003_69648)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_3003_69648)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 24.7266,
    cy: 41.7285,
    rx: 10,
    ry: 7.5,
    transform: "rotate(-90 24.7266 41.7285)",
    fill: "#F85A17",
    fillOpacity: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f_3003_69648)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 53.7266,
    cy: 41.7285,
    rx: 10,
    ry: 7.5,
    transform: "rotate(-90 53.7266 41.7285)",
    fill: "#F85A17",
    fillOpacity: 0.5
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_d_3003_69648)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.5029 31.8698C23.3182 32.4552 22.4828 34.696 22.8972 36.2394C23.7932 39.5764 28.4765 41.6419 31.7244 42.8852C33.9135 40.1849 36.9331 36.0553 36.0372 32.7185C35.6228 31.1752 33.7768 29.6528 31.5922 30.2382C30.3721 30.5651 29.5869 31.8024 29.0492 32.9221C28.0227 32.2216 26.7231 31.5429 25.503 31.8698L25.5029 31.8698Z",
    fill: "#F85A17"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_d_3003_69648)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.9502 31.8698C56.135 32.4552 56.9704 34.696 56.5559 36.2394C55.6599 39.5764 50.9767 41.6419 47.7287 42.8852C45.5396 40.1849 42.52 36.0553 43.416 32.7185C43.8303 31.1752 45.6763 29.6528 47.8609 30.2382C49.081 30.5651 49.8662 31.8024 50.4039 32.9221C51.4304 32.2216 52.73 31.5429 53.9501 31.8698L53.9502 31.8698Z",
    fill: "#F85A17"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.75,
    filter: "url(#filter7_i_3003_69648)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.7261 55.7285C45.6114 55.7285 50.5244 51.2065 51.6822 48.0215C51.9091 47.3972 51.3058 46.9032 50.6606 47.0613C48.491 47.593 43.9176 48.5747 39.7261 48.5747C35.5347 48.5747 30.9612 47.593 28.7917 47.0613C28.1465 46.9032 27.5432 47.3972 27.7701 48.0215C28.9279 51.2065 33.8409 55.7285 39.7261 55.7285Z",
    fill: "#262626"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter8_f_3003_69648)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.7261 55.7285C45.6114 55.7285 50.5244 51.2065 51.6822 48.0215C51.9091 47.3972 51.3058 46.9032 50.6606 47.0613C48.491 47.593 43.9176 48.5747 39.7261 48.5747C35.5347 48.5747 30.9612 47.593 28.7917 47.0613C28.1465 46.9032 27.5432 47.3972 27.7701 48.0215C28.9279 51.2065 33.8409 55.7285 39.7261 55.7285Z",
    fill: "#FBF2C3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_3003_69648",
    x: 14.2266,
    y: 20.7285,
    width: 31,
    height: 31,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_3003_69648"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_3003_69648",
    x: 34.2266,
    y: 20.7285,
    width: 31,
    height: 31,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_3003_69648"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_3003_69648",
    x: 15.2266,
    y: 4.72852,
    width: 48,
    height: 43,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7,
    result: "effect1_foregroundBlur_3003_69648"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_3003_69648",
    x: 3.22656,
    y: 17.7285,
    width: 43,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7,
    result: "effect1_foregroundBlur_3003_69648"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_3003_69648",
    x: 32.2266,
    y: 17.7285,
    width: 43,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7,
    result: "effect1_foregroundBlur_3003_69648"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d_3003_69648",
    x: 18.7949,
    y: 27.1094,
    width: 21.4043,
    height: 20.7754,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.970833 0 0 0 0 0.353545 0 0 0 0 0.0889931 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3003_69648"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3003_69648",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_d_3003_69648",
    x: 39.2539,
    y: 27.1094,
    width: 21.4043,
    height: 20.7754,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.970833 0 0 0 0 0.353545 0 0 0 0 0.0889931 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3003_69648"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3003_69648",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_i_3003_69648",
    x: 27.7217,
    y: 47.0312,
    width: 24.0088,
    height: 8.69727,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_3003_69648"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_f_3003_69648",
    x: 20.7217,
    y: 40.0312,
    width: 38.0088,
    height: 22.6973,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5,
    result: "effect1_foregroundBlur_3003_69648"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_3003_69648",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(39.2266 39.7285) rotate(89.6589) scale(23.4456)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.916667,
    stopColor: "#FBF2C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7CFDA"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_3003_69648",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(29.7266 36.2285) rotate(90) scale(10.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7CFDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBF2C3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_3003_69648",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(29.7266 36.2285) rotate(90) scale(10.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7CFDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBF2C3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_3003_69648",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(10.5 10.5) rotate(90) scale(10.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7CFDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBF2C3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_3003_69648",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(10.5 10.5) rotate(90) scale(10.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7CFDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBF2C3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_3003_69648",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(39.2266 39.7285) rotate(89.6589) scale(23.4456)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.916667,
    stopColor: "#FBF2C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7CFDA"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReactionObsessed);
export default __webpack_public_path__ + "static/media/reaction_obsessed.6fb7e5da6980da410ce36587145be3eb.svg";
export { ForwardRef as ReactComponent };